import './VTable.scss';

import { VGrid } from 'vui';

export default VGrid('table-row');
